// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import AbortController from "abort-controller";
import { GraphQLClient } from "graphql-request";
import Cookies from "universal-cookie";
import * as Sentry from "@sentry/react";
import { CURRENT_VERSION, setIsServiceDown } from "../config/variables";
// import { SeverityLevel } from "@sentry/types";

const cookies = new Cookies();

// const location = useLocation();

// let prevPath = "";
// let currentPath = "";

let endpoint;
let endpoint_report;
let endpoint_queue;
if (process.env.REACT_APP_ENVIRONMENT.trim() === "development") {
  endpoint = "https://vpi-dev-api.npr.digital/graphql";
  // endpoint = "https://vpi-dev-ec2-api.npr.digital/graphql";
  // endpoint = "http://localhost:5000/graphql";
  // endpoint = "https://vpi-prod-api.npr.digital/graphql";
  endpoint_report = "https://vpi-dev-api.npr.digital/graphql";
  console.log("running on development");
} else if (process.env.REACT_APP_ENVIRONMENT.trim() === "production") {
  endpoint = "https://vpi-hostinger.npr.digital/graphql";
  // endpoint = "https://vpi-prod-api.npr.digital/graphql";
  endpoint_report = "https://vpi-queue-hostinger.npr.digital/graphql";
  endpoint_queue = "https://vpi-queue-hostinger.npr.digital/graphql";
  console.log("running on production");
}

// const controller = new AbortController();

export const graphQLClient = new GraphQLClient(endpoint, {
  // signal: controller.signal,
  credentials: "include",
  mode: "cors",
});
export const graphQLClientReport = new GraphQLClient(endpoint_report, {
  // signal: controller.signal,
  credentials: "include",
  mode: "cors",
});
export const graphQLClientQueue = new GraphQLClient(endpoint_queue, {
  credentials: "include",
  mode: "cors",
});
// console.log("graphQLClient", graphQLClient);

// const timeoutId = setTimeout(() => {
//   console.log("TIMEOUT CALLED");
//   controller.abort();
//   console.log("timeout");
//   console.log("graphQLClient2", graphQLClient);
// }, 10000);

// const convertGraphQLQueryToJson = (query) => {
//   const ast = parse(query);
//   const queryAsJson = {};

//   ast.definitions.forEach((definition) => {
//     if (definition.kind === "OperationDefinition") {
//       queryAsJson.operationType = definition.operation;
//       queryAsJson.name = definition.name?.value;
//       queryAsJson.selectionSet = definition.selectionSet.selections.map(
//         (selection) => {
//           return {
//             name: selection.name.value,
//             fields: selection.selectionSet?.selections.map(
//               (field) => field.name.value
//             ),
//           };
//         }
//       );
//     }
//     if (definition.kind === "VariableDefinition") {
//       queryAsJson.variables = definition.variableDefinitions.map((variable) => {
//         return {
//           name: variable.variable.name.value,
//           type: variable.type.name?.value || "ComplexType",
//         };
//       });
//     }
//   });

//   return queryAsJson;
// };

const graphqlMiddleware = (client) => async (query, variables) => {
  try {
    const data = await client.request(query, variables);
    Sentry.addBreadcrumb({
      category: "graphql-query",
      message: "GraphQL Query",
      data: {
        query,
        variables,
      },
    });
    Sentry.addBreadcrumb({
      category: "graphql-response",
      message: "GraphQL Response",
      data: {
        response: data,
      },
    });
    return data;
  } catch (error) {
    Sentry.addBreadcrumb({
      category: "graphql-error",
      message: "GraphQL Error",
      data: {
        name: error.name || "-",
        message: error.message || "-",
        cause: error.cause || "-",
      },
    });
    setIsServiceDown(true);
    console.error(error);
    console.error(error.name);
    console.error(error.message);
    console.error(error.cause);
    Sentry.captureException(error);
    throw error;
  }
};

export const graphQLClientWithHeader = () => {
  let token = cookies.get("access_token");
  graphQLClient.setHeader("authorization", `Bearer ${token}`);
  graphQLClientReport.setHeader("fe-version", CURRENT_VERSION);
  return {
    ...graphQLClient,
    request: graphqlMiddleware(graphQLClient),
  };
};

export const graphQLClientReportWithHeader = () => {
  let token = cookies.get("access_token");
  graphQLClientReport.setHeader("authorization", `Bearer ${token}`);
  graphQLClientReport.setHeader("fe-version", CURRENT_VERSION);
  return {
    ...graphQLClientReport,
    request: graphqlMiddleware(graphQLClientReport),
  };
};

export const graphQLClientQueueWithHeader = () => {
  let token = cookies.get("access_token");
  graphQLClientQueue.setHeader("authorization", `Bearer ${token}`);
  graphQLClientReport.setHeader("fe-version", CURRENT_VERSION);
  return {
    ...graphQLClientQueue,
    request: graphqlMiddleware(graphQLClientQueue),
  };
};
